import { type GetHookResponse, type WithEnabled } from '../hooks'
import { roleListKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type RoleListInput, type RoleListSuccess, type RoleData } from '@terros/common'

export type UseRoleProps = WithEnabled & RoleListInput

export function useRoles({ enabled, ...input }: UseRoleProps = {}): GetHookResponse<RoleData[]> {
  return useTantalimQuery<RoleListInput, RoleListSuccess, RoleData[]>({
    url: '/role/list',
    queryKey: roleListKey(input),
    input,
    convertResponse: (responseData) => {
      responseData.roles.sort((a, b) => a.name.localeCompare(b.name))
      return responseData.roles
    },
    options: {
      enabled,
    },
  })
}
